import { useTheme } from "../context/ThemeContext";

export const useCommonConfig = () => {
  const { theme } = useTheme();

  const isDark = theme === "dark";

  return { theme, isDark };
};
